import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { updateBreadcrumbs } from '~src/spacesPlatform/actions/UpdateBreadcrumbsAction';
import { selectContentTotalLength } from '~src/spacesPlatform/selectors/ContentSelectors';

import { AppState } from '../../../../app/state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../../../app/utils/ConnectUtils';
import { AllServerUsersSpace, AllServerUsersSpaceDispatchProps, AllServerUsersSpaceOwnProps, AllServerUsersSpaceStateProps } from './AllServerUsersSpace';

const mapStateToProps: MapStateToProps<AllServerUsersSpaceStateProps> = (state: AppState) => ({
  numberOfFetchedUsers: selectContentTotalLength(state),
  isBusyFetchingItems: state.contentExplorer.content.isBusy,
});

const mapDispatchToProps: MapDispatchToProps<AllServerUsersSpaceDispatchProps> = (dispatch) => bindActionCreators({
  requestSpaceContents,
  updateBreadcrumbs
}, dispatch);

export const ConnectedAllServerUsersSpace: React.ComponentClass<AllServerUsersSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(AllServerUsersSpace);
